import { AlertTriangle, RefreshCw, Home } from 'lucide-react'
import { Button } from '@/modules/shared/components/ui/button'

export function UncaughtErrorPage({ error, reset }: { error?: Error, reset?: () => void }) {
  const handleReload = () => {
    if (reset) {
      reset()
    } else {
      window.location.reload()
    }
  }

  const handleGoHome = () => {
    window.location.href = '/'
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50 p-6 text-center">
      <div className="relative mb-8">
        <div className="absolute inset-0 blur-2xl opacity-20 bg-red-500 rounded-full animate-pulse" />
        <div className="relative bg-white p-6 rounded-2xl shadow-xl border border-red-100 ring-4 ring-red-50/50">
          <AlertTriangle size={64} className="text-red-500" />
        </div>
      </div>

      <h1 className="text-3xl font-bold text-slate-900 mb-4 tracking-tight">
        Algo não deu certo
      </h1>
      
      <p className="text-lg text-slate-600 mb-8 max-w-md leading-relaxed">
        Não conseguimos processar sua solicitação no momento. Não se preocupe, os dados do seu sistema estão seguros.
      </p>

      {error && import.meta.env.DEV && (
        <div className="w-full max-w-2xl bg-slate-900 rounded-xl p-4 mb-8 overflow-auto text-left border border-slate-800 shadow-inner">
          <p className="text-red-400 font-mono text-sm mb-2 font-bold uppercase tracking-wider">Erro Detalhado:</p>
          <pre className="text-slate-300 font-mono text-xs whitespace-pre-wrap leading-relaxed">
            {error.stack || error.message}
          </pre>
        </div>
      )}

      <div className="flex flex-col sm:flex-row gap-3 w-full max-w-xs sm:max-w-md">
        <Button 
          onClick={handleReload}
          className="flex-1 bg-red-600 hover:bg-red-700 text-white font-semibold h-12 rounded-xl transition-all active:scale-95 shadow-lg shadow-red-200"
        >
          <RefreshCw size={18} className="mr-2" />
          Tentar novamente
        </Button>
        <Button 
          variant="outline"
          onClick={handleGoHome}
          className="flex-1 border-slate-200 hover:bg-slate-50 text-slate-700 font-semibold h-12 rounded-xl transition-all active:scale-95"
        >
          <Home size={18} className="mr-2" />
          Ir para o início
        </Button>
      </div>

      <footer className="mt-12 text-slate-400 text-xs">
        Se o problema persistir, por favor entre em contato com o suporte.
      </footer>
    </div>
  )
}
